export const PATH_INDEX = '/';
export const PATH_FOUNDS = '/Funds/:address';

export const LINK_PATH_HOME = 'https://bishares.finance/';
export const LINK_PATH_ABOUT = 'https://bishares.finance/about-us';
export const LINK_PATH_FARMS = 'https://farms.bishares.finance';

export const API_APE_SWAP_GRAPH = 'https://graph.apeswap.finance/subgraphs/name/ape-swap/apeswap-subgraph';
